module.exports = __webpack_public_path__ + "img/no-commercialisation.e57d0b90.svg";